// T-15 — helpers puros de la página Visualization.
//
// Extraídos de `src/pages/Visualization.tsx` (que renderiza Highcharts, por lo
// que no se puede testear el componente completo). Son puros y sin dependencias.

export type VizSeries = {
  name: string
  data: { year: number; value: number }[]
}

/** Categorías del eje X a partir de la primera serie (sus años como string),
 *  o `[]` si no hay series. */
export function getChartYears(series: VizSeries[] | undefined): string[] {
  if (!series || !series[0]) {
    return []
  }
  return series[0].data.map(point => String(point.year))
}

/** Mapea las series a la forma de highcharts `{ name, data: number[] }` (solo
 *  los valores), o `[]` si no hay series. */
export function buildVisualizationSeries(
  series: VizSeries[] | undefined,
): { name: string; data: number[] }[] {
  if (!series) {
    return []
  }
  return series.map(item => ({
    name: item.name,
    data: item.data.map(point => point.value),
  }))
}